// src/pages/SignupLoginPage.tsx
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from '../services/firebase';
import { useAuth } from '../contexts/AuthContext';
import { GoogleIcon, EmailIcon } from '../components/CustomIcons';
import AuthLayout from './AuthLayout';
import queryString from 'query-string';
import {
  addUser,
  ifUserExists
} from "../services/firebase";


const SignupLoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { getDashboardRoute } = useAuth();
  const [error, setError] = useState('');
  const location = useLocation();

  const { token } = queryString.parse(location.search);

  React.useEffect(() => {
    if (token && typeof token === 'string') {
      
      localStorage.setItem('joinCode', token);
    }
  }, [token]);

  const signupWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, new GoogleAuthProvider().setCustomParameters({ prompt: "select_account" }));
      // Firebase user object
      const user = result.user;
      const createUser = await addUser({
        uid: user.uid,
        email: user.email ? user.email : '',
        role: "user",
        verified: true,
        name: user.displayName ? user.displayName : '',
        photoURL: user.photoURL ? user.photoURL : '',
      })
      
      if (createUser) {
        console.log("User created successfully");
        if(localStorage.getItem('joinCode')){
          navigate(`/${localStorage.getItem('joinCode')}`);
          //localStorage.removeItem('joinCode');
          //return;
        } else {
          setTimeout(() => {
            navigate('/dashboard');
          }, 1000); // slight delay to ensure user data is set
          //
        }
        
      } else {
        setError('Failed to create user');
      }
        
    } catch {
      setError('Failed to sign in with Google');
    }
  };

  return (
    <AuthLayout title="The league where last place is legendary">
      <div className="formGroup">
        <button onClick={signupWithGoogle} type="button" className="otherBtn">
          <GoogleIcon /><span>Continue with Google</span>
        </button>
      </div>

      <div className="formGroup">
        <Link to="/signup" className="otherBtn">
          <EmailIcon /><span>Continue with email</span>
        </Link>
      </div>

      <div className="alignCenter">Already have an account?</div>
      <Link to="/login" className="btnStyle">Sign in</Link>

      {error && <p style={{ color: 'red' }}>{error}</p>}
    </AuthLayout>
  );
};

export default SignupLoginPage;
